module.exports = __webpack_public_path__ + "img/mtc-core-logo.dad01661.png";